import FLOW_TYPES, {
  type FlowType,
} from '@/services/funnelService/consts/flowType';

// Retail promoCode from localStorage, only on the retail one-time flow (undefined otherwise).
export const getRetailPromoCode = (flowType: FlowType): string | undefined =>
  flowType === FLOW_TYPES.CurologyRetailOneTimeSkin &&
  typeof window !== 'undefined'
    ? window.localStorage.getItem('retailPromoCode') ?? undefined
    : undefined;
